export default __webpack_public_path__ + "static/media/checkerCover.8d76e527.jpg";